var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconEditResident(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon_Admin"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Edit Square"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Fill 1",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.577 22.3685H7.753C4.312 22.3685 2 19.9535 2 16.3595V8.04548C2 4.45148 4.312 2.03648 7.753 2.03648H11.492C11.906 2.03648 12.242 2.37248 12.242 2.78648C12.242 3.20048 11.906 3.53648 11.492 3.53648H7.753C5.169 3.53648 3.5 5.30648 3.5 8.04548V16.3595C3.5 19.0985 5.169 20.8685 7.753 20.8685H16.577C19.161 20.8685 20.831 19.0985 20.831 16.3595V12.3315C20.831 11.9175 21.167 11.5815 21.581 11.5815C21.995 11.5815 22.331 11.9175 22.331 12.3315V16.3595C22.331 19.9535 20.018 22.3685 16.577 22.3685Z",
    fill: "#3956C7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill 3",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.86803 15.4281H11.845C12.225 15.4281 12.581 15.2811 12.85 15.0121L20.359 7.50315C20.667 7.19515 20.837 6.78515 20.837 6.34915C20.837 5.91215 20.667 5.50115 20.359 5.19315L19.142 3.97615C18.505 3.34115 17.469 3.34115 16.831 3.97615L9.35803 11.4491C9.09903 11.7081 8.95203 12.0521 8.94303 12.4171L8.86803 15.4281ZM11.8449 16.9281H8.09886C7.89686 16.9281 7.70286 16.8461 7.56186 16.7011C7.42086 16.5571 7.34386 16.3621 7.34886 16.1591L7.44286 12.3801C7.46186 11.6281 7.76486 10.9211 8.29686 10.3881H8.29786L15.7709 2.91506C16.9929 1.69506 18.9799 1.69506 20.2019 2.91506L21.4189 4.13206C22.0119 4.72406 22.3379 5.51106 22.3369 6.34906C22.3369 7.18706 22.0109 7.97306 21.4189 8.56406L13.9099 16.0731C13.3589 16.6241 12.6249 16.9281 11.8449 16.9281Z",
    fill: "#3956C7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill 5",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.7308 9.91659C19.5388 9.91659 19.3468 9.84359 19.2008 9.69659L14.6348 5.13059C14.3418 4.83759 14.3418 4.36259 14.6348 4.06959C14.9278 3.77659 15.4018 3.77659 15.6948 4.06959L20.2608 8.63659C20.5538 8.92959 20.5538 9.40359 20.2608 9.69659C20.1148 9.84359 19.9228 9.91659 19.7308 9.91659Z",
    fill: "#3956C7"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconEditResident);
export default __webpack_public_path__ + "static/media/iconEditResident.fa1c2d2173d4f7705b5017ffa28af550.svg";
export { ForwardRef as ReactComponent };